import doc                 from '@widesk-core/decorators/doc';
import AbstractUserModel   from './AbstractUserModel';
import FondationsUserModel from '@models/fondations/UserModel';
import { modelUrn }        from '@widesk-core/decorators/modelUrn';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import { computed }        from 'mobx';

@doc.urnResource('user')
export default class UserModel extends AbstractUserModel {
	@modelUrn(FondationsUserModel) declare user: FondationsUserModel;

	@computed
	public get test() {
		return this.get('urnData', {});
	}

	public renderName(props?: RenderNameProps<this> & UserNameProps) {
		return super.renderName(props);
	}
}
